import React, { useContext }                                   from "react";
import { View, FlatList, StyleSheet, Text }                    from "react-native";
import Col                                                     from "../../layouts/Col";
import Row                                                     from "../../layouts/Row";
import palette                                                 from "../../styles/palette";
import CustomersContext                                        from "../../contexts/CustomersContext";
import Avatar                                                  from "../Avatar";
import AnimatedLogo                                            from "../Logo/AnimatedLogo/index";

export default function SuggestedCustomersList() {
  const { getCustomers, loading, customers } = useContext(CustomersContext);
  return (
    <View style={[styles.customers_list__container]}>
      {loading && <CustomersLoadingIndicator />}
      <FlatList
        style={{ display: loading ? "none" : "flex" }}
        refreshing={loading}
        onRefresh={getCustomers}
        data={customers}
        renderItem={renderCustomerItem}
        keyExtractor={(item) => `${item.id}`}
      />
    </View>
  );
}

const renderCustomerItem = ({ item }) => {
  return (
    <View style={[styles.customers_list__item_container]}>
      <Row pl={16} pr={24} style={{ height: 74 }}>
        <Col leftCenter maxWidth={60}>
          <Avatar size={45} first_name={item.first_name} last_name={item.last_name} />
        </Col>
        <Col leftCenter style={{ flex: "auto",  }}>
          <Text numberOfLines={1} style={[styles.customers_list__item_name]}>
            {item.first_name} {item.last_name}
          </Text>
          <Text numberOfLines={1} style={[styles.customers_list__item_text]}>
            {item.phone}
          </Text>
        </Col>
      </Row>
    </View>
  );
};

const CustomersLoadingIndicator = () => {
  return (
    <View style={[styles.customers_list__loading_indicator_container]}>
      <View dataSet={{ cls: "logo-loader" }}>
        <AnimatedLogo height={60} width={60} />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  customers_list__container: {
    flex: 1,
  },
  customers_list__loading_indicator_container: {
    flex: 1,
    backgroundColor: "#fbfbfb",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
  },
  customers_list__item_control_bar_container: {
    height: 65,
  },
  customers_list__item_text: {
    // fontFamily: "acumin-pro, san-serif",
    fontSize: 14,
    fontWeight: "400",
  },
  customers_list__item_name: {
    // fontFamily: "acumin-pro, san-serif",
    fontSize: 16,
    fontWeight: "500",
  },
  customers_list__item_container: {
    backgroundColor: palette.white,
    borderTopColor: palette.light_grey,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: palette.light_grey,
  },
});
